import { CyberscoutLPSection } from 'components/cyberscout/CyberscoutLPSection'
import React from 'react'

export function CyberscoutPageSections() {
  return (
    <>
      <CyberscoutLPSection section="section_support" />
      <CyberscoutLPSection section="section_alerts" extraProps={{ imagePlacement: 'right' }} />
      <CyberscoutLPSection section="section_credit_fraud" />
    </>
  )
}
